var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8404 6.15956C18.231 6.55009 18.231 7.18325 17.8404 7.57378L9.28088 16.1333H16.1281C16.6804 16.1333 17.1281 16.581 17.1281 17.1333C17.1281 17.6856 16.6804 18.1333 16.1281 18.1333H6.86667C6.31438 18.1333 5.86667 17.6856 5.86667 17.1333V7.87189C5.86667 7.31961 6.31438 6.87189 6.86667 6.87189C7.41895 6.87189 7.86667 7.31961 7.86667 7.87189V14.7191L16.4262 6.15956C16.8168 5.76904 17.4499 5.76904 17.8404 6.15956Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowLeftDown.f861259227bed96c1cfebb1d6cef1169.svg";